import React from "react";

import Divider from "@mui/material/Divider";
import styled from "@mui/material/styles/styled";

import IconButton, { IconButtonProps } from "@rui/IconButton";
import Stack, { Row, StackProps } from "@rui/Stack";

type SideNavItemProps = StackProps & { expanded: boolean };
type SideNavButtonProps = SideNavItemProps & {
  active?: boolean;
  highlight?: boolean;
};

export const SideNavLogoContainer = styled(Row)(({ theme }) => ({
  padding: theme.spacing(2, 0),
  [theme.breakpoints.up("md")]: {
    paddingTop: theme.spacing(1.5),
  },
}));

export const SideNavButton = styled<React.FC<SideNavButtonProps>>(
  ({ active: _a, expanded: _e, ...props }) => <Row {...props} />
)(({ active, expanded, theme }) => ({
  transition: "all 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
  alignItems: "center",
  cursor: "pointer",
  borderRadius: theme.corners.base,
  color: active ? "#FFF" : theme.palette.shades.ghost[700],
  "&:hover": {
    backgroundColor: theme.palette.transparent.white[10],
    color: "#FFF",
  },
  height: "36px",
  width: "100%",
  minWidth: expanded ? "200px" : 0,
  padding: theme.spacing(1),
}));

export const SideNavItemContainer = styled(
  ({ expanded: _e, ...props }: SideNavItemProps) => <Stack {...props} />
)(({ expanded, onClick, theme }) => ({
  transition: "all 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
  cursor: onClick ? "pointer" : "default",
  borderRadius: "8px",
  padding: theme.spacing(expanded ? 1 : 0),
  backgroundColor: theme.palette.transparent.white[4],
  color: theme.palette.shades.ghost[700],
  overflow: "hidden",
}));

export const SideNavContentContainer = styled(Stack)(({ theme }) => ({
  position: "relative",
  height: "100%",
  width: "100%",
  overflow: "hidden",
  overflowY: "scroll",
  msOverflowStyle: "none",
  scrollbarWidth: "none",
  padding: theme.spacing(0, 0, 2),
  "::-webkit-scrollbar": {
    display: "none",
  },
}));

export const SideNavDivider = styled(Divider)(({ theme }) => ({
  backgroundColor: theme.palette.overlay.primary[28],
  margin: theme.spacing(1, 0),
}));

export const SideNavToggleButton = styled<React.FC<IconButtonProps>>(
  (props) => <IconButton variant="outlined" size="small" {...props} />
)(({ theme }) => ({
  backgroundColor: theme.palette.transparent.white[2],
  borderColor: theme.palette.transparent.white[20],
  borderRadius: theme.corners.base,
  "& .MuiSvgIcon-root": {
    color: "#FFF",
  },
  "&:hover": {
    backgroundColor: theme.palette.transparent.white[8],
    borderColor: theme.palette.transparent.white[20],
    "& .MuiSvgIcon-root": {
      color: "#FFF",
    },
  },
}));
